import { trackPage, trackAction, trackUser } from './legacy/analytics';
import * as analytics from './legacy/analytics';
import useAnalytics from './legacy/useAnalytics';
import Analytics from './components/Analytics';
import Page from './components/Page';
import useTrackAction from './hooks/useTrackAction';
import useCircleciAnonymousId from './hooks/useCircleciAnonymousId';
export {
  trackPage,
  trackAction,
  trackUser,
  useAnalytics,
  Analytics,
  Page,
  useTrackAction,
  useCircleciAnonymousId,
};
export default analytics;
